import React, { useEffect } from "react";
import { styled } from "styled-components";
import { useEditor, useNode } from "@craftjs/core";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import EditIcon from "@mui/icons-material/Edit";
import { ReactComponent as MoveIcon } from "@assets/images/segmentEditor/moveBlock.svg";
import { useDispatch, useSelector } from "react-redux";
import { setToolBarVisible } from "../../../../redux/reducers/segmentBuilder";
import { toggleSegmentSettings } from "../../../../redux/actions/segmentSettings";
import { useClone } from "../../../../utils/contentBlocksEditorUtils";
import { colors } from "../../../../utils";
import { openModal } from "../../../../redux/reducers/dialog";
import { handleMenuChange } from "../../../../redux/reducers/segmentBuilder";
import {
  getSelectedMenu,
  getWheelSegments,
} from "../../../../redux/selectors/segmentBuilderSelectors";
import { openMoveBlockModal } from "../../../../redux/reducers/moveBlockDialog";
import { deleteWheelMedia } from "../../../../services/api";
import { useParams } from "react-router-dom";

const IconsView = styled.div`
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0px 5px;
  height: 28px;
  right: -2px;
  position: absolute;
  z-index: 10;
  top: -28px;
`;

const IconButton = styled.div`
  svg {
    color: white !important;
    cursor: pointer;
  }
`;

export const BlockIndicator = ({ children }) => {
  const { id } = useNode();
  const { actions, query, isActive } = useEditor((_, query) => ({
    isActive: query.getEvent("selected").contains(id),
  }));

  const { id: wheelId } = useParams();

  const {
    connectors: { drag },
    moveable,
    deletable,
    isHovered,
    data,
  } = useNode((node) => ({
    isHovered: node.events.hovered,
    moveable: query.node(node.id).isDraggable(),
    deletable: query.node(node.id).isDeletable(),
    data: node.data,
  }));


  const selectedMenu = useSelector(getSelectedMenu);
  const wheelData = useSelector(getWheelSegments);

  const { handleClone } = useClone(query, actions);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isActive) dispatch(handleMenuChange({ num: 3 }));
  }, [isActive]);

  useEffect(() => {
    if (selectedMenu == 1 || selectedMenu == 2) actions.selectNode(null);
  }, [selectedMenu]);

  const onEditClick = () => {
    dispatch(handleMenuChange({ num: 3 }));
    dispatch(toggleSegmentSettings(true));
    actions.selectNode(id);
  };

  const onConfirmDelete = async () => {
    console.log("Deleting node:", data?.name, data?.props);
    try {
      actions.delete(id);
      if (data?.name === "ImageWidget" || data?.name === "ImageWithText") {
        const response = await deleteWheelMedia({
          url: data?.props?.image?.src,
          wheel_id: wheelId,
        });
        console.log("Delete API response:", response);
      }
      if (data?.name === "VideoWidget") {
        const response = await deleteWheelMedia({
          url: data?.props?.src,
          wheel_id: wheelId,
        });
        console.log("Delete API response:", response);
      }
      if (data?.name === "ImageGridWidget") {
        for (let i = 0; i < data?.props?.images?.length; i++) {
          const response = await deleteWheelMedia({
            url: data?.props?.images[i]?.src,
            wheel_id: wheelId,
          });
          console.log("Delete API response:", response);
        }
      }
      if (data?.name === "DocumentWidget") {
        for (let i = 0; i < data?.props?.documents?.length; i++) {
          const response = await deleteWheelMedia({
            url: data?.props?.documents[i]?.src,
            wheel_id: wheelId,
          });
          console.log("Delete API response:", response);
        }
      }
      if (data?.name === "AudioWidget") {
        for (let i = 0; i < data?.props?.audios?.length; i++) {
          const response = await deleteWheelMedia({
            url: data?.props?.audios[i]?.src,
            wheel_id: wheelId,
          });
          console.log("Delete API response:", response);
        }
      }
    } catch (error) {
      console.error("Error deleting media:", error);
      // Show error toast or notification here if needed
    }
  };

  const onDeleteClick = () => {
    dispatch(
      openModal({
        onConfirm: onConfirmDelete,
        title: "Delete block",
        subtitle: "Are you sure you want to delete this block?",
      })
    );
  };

  const handleMove = () => {
    dispatch(openMoveBlockModal({ blockId: id }));
  };

  const color = isActive ? "#2196F3" : colors.purple;

  return (
    <div
      style={{
        position: "relative",
        border: isHovered ? `2px  ${color} dashed` : `2px solid transparent`,
      }}
    >
      {(isHovered || isActive) && (
        <IconsView style={{ backgroundColor: color }}>
          {moveable && (
            <IconButton ref={drag}>
              <DragIndicatorIcon style={{ cursor: "move" }} />
            </IconButton>
          )}

          {wheelData?.length > 1 && (
            <IconButton onClick={handleMove}>
              <MoveIcon />
            </IconButton>
          )}

          <IconButton onClick={onEditClick}>
            <EditIcon />
          </IconButton>

          <IconButton onClick={(e) => handleClone(e, id)}>
            <ContentCopyIcon />
          </IconButton>
          {deletable && (
            <IconButton onClick={onDeleteClick}>
              <DeleteIcon />
            </IconButton>
          )}
        </IconsView>
      )}
      {children}
    </div>
  );
};
